
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watch/[webinarId]",
      function () {
        return require("private-next-pages/watch/[webinarId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/watch/[webinarId]"])
      });
    }
  